"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowForward = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ArrowForward = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M18.555 10.56c.285.28.445.662.445 1.06v.76a1.533 1.533 0 01-.445 1.06L8.168 23.704a1.015 1.015 0 01-1.434 0l-1.435-1.42a.976.976 0 010-1.4L14.29 12 5.3 3.117a.995.995 0 010-1.42L6.734.295a1.016 1.016 0 011.434 0L18.555 10.56z" })); };
exports.ArrowForward = ArrowForward;
//# sourceMappingURL=arrow-forward.js.map